import React from 'react';
import Group from '@spa/shared/components/Filters/Group';
import { useTranslation } from 'next-i18next';
import BudgetRange from '@spa/shared/components/Filters/BudgetRange';
import PropTypes from 'prop-types';
import CheckboxFilter from '@spa/shared/components/Filters/Checkbox';

const minPrice = 0;
const maxPrice = 250000;

const Budget = ({ fields, onMultiChangeHandler, onChangeEventHandler, priceHistogram = {}, currency = 'EUR' }) => {
  const { t } = useTranslation('translations');

  return (
    <Group title={t('filters.sections.budget')}>
      <BudgetRange
        histogram={priceHistogram}
        onChange={onMultiChangeHandler}
        start={fields['budget-min']}
        end={fields['budget-max']}
        startName="budget-min"
        endName="budget-max"
        currencyCode={currency}
        min={minPrice}
        max={maxPrice}
      />
      <CheckboxFilter
        name="bills-included"
        value="true"
        onChange={onChangeEventHandler}
        selected={fields['bills-included'] === 'true'}
        label={t('global.labels.with_bills')}
      />
    </Group>
  );
};

Budget.propTypes = {
  fields: PropTypes.object.isRequired,
  priceHistogram: PropTypes.object,
  onMultiChangeHandler: PropTypes.func.isRequired,
  onChangeEventHandler: PropTypes.func.isRequired,
  currency: PropTypes.string
};

export default Budget;
